(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function syncSticky(root) {
    var observeSel = root.getAttribute("data-gtg-observe");
    var mainBtn = observeSel ? qs(observeSel) : null;
    var stickyBtn = qs("[data-gtg-sticky-submit]", root);
    var labelEl = qs("[data-gtg-sticky-label]", root);
    var priceEl = qs("[data-gtg-sticky-price]", root);
    if (!stickyBtn) return { mainBtn: mainBtn, stickyBtn: stickyBtn };
    if (mainBtn) {
      stickyBtn.disabled = !!mainBtn.disabled;
      var span = mainBtn.querySelector("span");
      if (span && labelEl) labelEl.textContent = (span.textContent || "").trim();
    }
    if (priceEl) {
      var sale = qs(".product__info-container .price-item--sale:not(s)");
      var regular = qs(".product__info-container .price__regular .price-item--regular");
      var pick = sale && (sale.textContent || "").trim() ? sale : regular;
      if (pick && (pick.textContent || "").trim()) {
        priceEl.textContent = (pick.textContent || "").trim();
      }
    }
    return { mainBtn: mainBtn, stickyBtn: stickyBtn };
  }

  function measureAndPad(root, on) {
    if (!on) {
      document.documentElement.style.removeProperty("--gtg-sticky-atc-h");
      return;
    }
    var h = Math.ceil(root.getBoundingClientRect().height || 0);
    if (h > 0) {
      document.documentElement.style.setProperty("--gtg-sticky-atc-h", h + "px");
    }
  }

  function initSticky() {
    var root = qs("[data-gtg-sticky-atc]");
    if (!root || root.dataset.gtgInit === "1") return;
    root.dataset.gtgInit = "1";

    /* Escape product-column containing block (scroll-trigger transform / sticky ancestors). */
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var parts = syncSticky(root);
    var mainBtn = parts.mainBtn;
    var shown = false;

    function show(on) {
      on = !!on;
      if (on === shown && root.classList.contains("is-visible") === on) {
        if (on) measureAndPad(root, true);
        return;
      }
      shown = on;
      root.classList.toggle("is-visible", on);
      root.hidden = !on;
      document.documentElement.classList.toggle("gtg-sticky-atc-active", on);
      if (on) {
        requestAnimationFrame(function () {
          measureAndPad(root, true);
        });
      } else {
        measureAndPad(root, false);
      }
    }

    if (mainBtn && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            /* Stay visible until main ATC returns into view — ignore other targets. */
            show(!entry.isIntersecting);
          });
        },
        { threshold: [0, 0.01, 1], rootMargin: "0px" }
      );
      io.observe(mainBtn);
      /* Initial state (IO may be async). */
      var rect = mainBtn.getBoundingClientRect();
      var inView = rect.bottom > 0 && rect.top < (window.innerHeight || 0);
      show(!inView);
    } else {
      show(true);
    }

    if (mainBtn) {
      var mo = new MutationObserver(function () {
        syncSticky(root);
      });
      mo.observe(mainBtn, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["disabled", "class"],
      });
    }

    document.addEventListener("change", function (e) {
      if (
        e.target &&
        e.target.matches(
          'input[name="id"], .product-form__input input, .quantity__input, select'
        )
      ) {
        setTimeout(function () {
          syncSticky(root);
        }, 50);
      }
    });

    window.addEventListener(
      "resize",
      function () {
        if (shown) measureAndPad(root, true);
      },
      { passive: true }
    );
  }

  function softKlaviyoDelay() {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.innerWidth >= 750) {
        if (tries >= 20) clearInterval(timer);
        return;
      }
      var nodes = document.querySelectorAll(
        '.needsclick, [class*="klaviyo"], [id*="klaviyo"]'
      );
      nodes.forEach(function (el) {
        if (el.dataset.gtgKlSoft === "1") return;
        var style = window.getComputedStyle(el);
        if (style.position !== "fixed") return;
        if (parseInt(style.zIndex || "0", 10) < 999) return;
        var rect = el.getBoundingClientRect();
        if (
          rect.width > window.innerWidth * 0.6 &&
          rect.height > window.innerHeight * 0.35
        ) {
          el.dataset.gtgKlSoft = "1";
          el.style.setProperty("opacity", "0.01", "important");
          el.style.setProperty("pointer-events", "none", "important");
          setTimeout(function () {
            el.style.removeProperty("opacity");
            el.style.removeProperty("pointer-events");
          }, 6000);
        }
      });
      if (tries >= 20) clearInterval(timer);
    }, 500);
  }

  function boot() {
    initSticky();
    softKlaviyoDelay();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function () {
    var root = qs("[data-gtg-sticky-atc]");
    if (root) root.dataset.gtgInit = "";
    initSticky();
  });
})();
